module.exports = {
	"articleTitle1": "Me, Myself & Totoro ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Totoro",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/art-sushi-rolling",
	"articleSnippet1": "Jan 12, 2016 ... When I'm looking to put my patriotism and faith in American individualism to the \ntest, there's only one way to eat: alone.",
	"articleSnippet2": "Jan 17, 2011 ... “First we make the sticky rice,” said Haeri Lee, manager of Totoro on State Street. \n“Then we marinate and mix it in with a special vinegar sauce.",
	"foodRecommendations": [],
	"articleTitle2": "Ann Arbor's sushi scene",
	"address": "215 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27975,
		"lng": -83.740382
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/totoro.json
// module id = 990
// module chunks = 0